module.exports = __webpack_public_path__ + "static/media/open-book.bca3ef98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/open-book.svg
// module id = 470
// module chunks = 0